<div class="menu">
  <div class="menu__title">{{ 'menu-widget.title' | customLocale }}</div>
  <div *ngFor="let menu of menus; trackBy: trackByFn" class="menu__item">
    <a [routerLink]="menu.link" routerLinkActive="active">
      {{ menu.title | customLocale }}
      <div appRedPoint class="red-point" [event]="redPointEvent(menu.link)"></div>
    </a>
  </div>
</div>
